import React, { useState } from 'react'
import './Styles/log.css'
import {Link, useNavigate} from'react-router-dom'
import { GoogleLogin } from '@react-oauth/google';
import {login} from '../app/features/cart';
import { useDispatch } from 'react-redux';
function Log() {
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const year = new Date().getFullYear();
  const [logdata, setdata] = useState({
    emailnumber:"",
    password:""
  });
  console.log(logdata.emailnumber,logdata.password)
  const adddata=(e)=>{
    const{name,value} = e.target;
    setdata(()=>{
        return{
          ...logdata,[name]:value
        }
    })
  }
  return (
    <>
    <div style={{backgroundColor:'white',height:'697px'}}>
      <div className="image">
        <img src="https://www.demandsphere.com/wp-content/uploads/2018/02/Amazon_logo-1024x358.png" alt="amzon.in" />
        <p>.in</p>
      </div>
      <div className="content">
      <div>
        <form action="submit">
        <div className="signin">
          <p className='Sign-name'>Sign in</p>
          <p className='email-name' style={{fontWeight:"500"}}>Email or mobile phone number</p>
          <input type="email number" name="emailnumber" id="email" className='input-signup' onChange={adddata} value={logdata.emailnumber}/>
          <div className="password" style={{fontWeight:"500"}}>Password</div>
          <input type="password" name="password" id="password" className='input-signup' style={{marginTop:"1em"}}  onChange={adddata} value={logdata.password}/>
          <br />
          <button className='continue'>Continue</button>
          <p className="terms-condition">By countinuing , you are gree to Amazon's <span className='condition'>Conditon of Use <span style={{color:'black'}}>and</span> Privacy Notice</span></p>
        </div>
        <div className="hr">
        <hr className='left-hr'/>New To Amazon?<hr className='right-hr'/>
        </div>
        </form>
      </div>
      </div>
     <div style={{width:'15em',display:'flex',justifyContent:'center',margin:'1em auto'}}><GoogleLogin
  onSuccess={credentialResponse => {
    dispatch(login(credentialResponse));
    navigator('/')
  }}
  onError={() => {
    console.log('Login Failed');
  }}
/></div>
      <div className="accnt"><Link to='../Singup' className='accnt-p' style={{textDecorationLine:'none',color:'black'}}>Create your Amazon account</Link></div>
     <hr className='hr-down'/>
     <div className="copywright">
      <p className='p-copyw'>Condition</p>
      <p className='p-copyw'>privacyNotice</p>
      <p className='p-copyw'>Help</p>
     </div>
     <div className="copywright">
      <div className='copy-wright'>&copy; 1996-{year},Amaon.com, Inc. or its affiliates</div>
     </div>
    </div>
    </>
  )
}

export default Log
